import base from './base';

import checkbox from './checkbox';

import datepicker from './datepicker';

import input from './input';

import select from './select';

import textarea from './textarea';

import resource from './resource';

import submit from './submit';

import nested from './nested';

import autocomplete from './autocomplete';

import form from './form';

import bitwise from './bitwise';

import action from './action';

import actionResult from './action-result';

import file from './file'

import radioGroup from './radio-group'

import radio from './radio'

import require from './require'

import scope from './scope'

import group from './group'

import groupItem from './group-item'

export default {
  base,
  checkbox,
  datepicker,
  input,
  select,
  textarea,
  resource,
  submit,
  nested,
  autocomplete,
  form,
  bitwise,
  action,
  actionResult, file,
  radioGroup,
  radio,
  require,
  scope,
  group,
  groupItem
}

